import React from 'react';
import { Box, VStack, Skeleton } from '@skin-seoul/design-system';
const AIInsightSkeleton = () => {
  return <Box width="100%" position="relative" data-sentry-element="Box" data-sentry-component="AIInsightSkeleton" data-sentry-source-file="AiInsight.skeleton.tsx">
      <VStack gap={2} alignItems="start" width="100%" data-sentry-element="VStack" data-sentry-source-file="AiInsight.skeleton.tsx">
        <Skeleton height="16px" width="100%" data-sentry-element="Skeleton" data-sentry-source-file="AiInsight.skeleton.tsx" />
        <Skeleton height="16px" width="95%" data-sentry-element="Skeleton" data-sentry-source-file="AiInsight.skeleton.tsx" />
        <Skeleton height="16px" width="85%" data-sentry-element="Skeleton" data-sentry-source-file="AiInsight.skeleton.tsx" />
      </VStack>
    </Box>;
};
export default AIInsightSkeleton;